import React, {useState, useEffect} from 'react';
import {getShortLang} from "../../../utils/helper";


export const UserLang = ({data = []}) => {
    return <div className="block-title-description-left-expert">
        <p className="title-l">Language</p>
        <p className="description-l">{data.map(lang => getShortLang(lang)).join(', ') || 'no information'}</p>
    </div>;
};